module.exports = __webpack_public_path__ + "img/categorie-crustaces-famille-boutrais-small.38b850c8.jpg";